import { render, staticRenderFns } from "./wsWebinarItemsList.vue?vue&type=template&id=2a071d14&scoped=true&"
import script from "./wsWebinarItemsList.vue?vue&type=script&lang=js&"
export * from "./wsWebinarItemsList.vue?vue&type=script&lang=js&"
import style0 from "./wsWebinarItemsList.vue?vue&type=style&index=0&id=2a071d14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a071d14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
